import { createSelector } from 'reselect';

const selectGamePage = state => state.get('gamePage');

export const selectLeaderboardOpen = () =>
  createSelector(selectGamePage, gp => gp.get('leaderboardOpen'));
